<div class="novo">

    <!-- Confirmação no lugar do formulário: o número do chamado é a única
         coisa que a pessoa precisa levar daqui. -->
    <nz-result *ngIf="criado != null" nzStatus="success"
        [nzTitle]="t('tkt.novo.aberto') + ' ' + criado.numero"
        [nzSubTitle]="t('tkt.novo.abertoHint')">
        <div nz-result-content *ngIf="caminhoLegivel">
            <strong>{{t('tkt.novo.categoria')}}:</strong> {{caminhoLegivel}}
        </div>
        <div nz-result-extra>
            <button nz-button nzType="primary" (click)="verMeusChamados()">
                {{t('tkt.novo.verMeus')}}
            </button>
            <button nz-button (click)="abrirOutro()">
                {{t('tkt.novo.abrirOutro')}}
            </button>
            <button nz-button nzType="text" (click)="fechar()">
                {{t('close')}}
            </button>
        </div>
    </nz-result>

    <nz-spin *ngIf="criado == null" [nzSpinning]="carregando" class="novo__area">

        <div class="novo__form">

            <!-- O ATENDIMENTO antes de tudo: e a configuracao dele que traz
                 fila, categoria, SLA e prazo. A lista vem das configuracoes
                 cadastradas, e nao dos contratos de quem esta logado — quem
                 abre quase nunca pertence ao contrato da central. -->
            <!-- SEMPRE visivel, mesmo com um atendimento so: quem abre precisa
                 ver onde o chamado vai cair antes de escrever. -->
            <div class="novo__campo" *ngIf="perguntaConfiguracoes">
                <label class="novo__label novo__label--req">
                    {{t('tkt.novo.contrato')}}
                </label>
                <nz-select [(ngModel)]="contratosConfiguracaoEscolhido" (ngModelChange)="onContratoChange()"
                    nzShowSearch [nzPlaceHolder]="t('tkt.novo.escolhaContrato')">
                    <nz-option *ngFor="let contrato of contratosConfiguracoes" [nzValue]="contrato.codecontract"
                        [nzLabel]="contrato.codecontract + ' - ' + contrato.nome"></nz-option>
                </nz-select>
                <span class="novo__hint">{{t('tkt.novo.contratoHint')}}</span>
            </div>

            <!-- O CLIENTE, que nao e o atendimento: quem abre pertence ao
                 contrato dele. Vem antes da empresa porque e ele que define
                 quais empresas aparecem. -->
            <div class="novo__campo" *ngIf="perguntaCliente">
                <label class="novo__label novo__label--req">
                    {{t('tkt.novo.cliente')}}
                </label>
                <nz-select [(ngModel)]="contratoClienteEscolhido" nzShowSearch
                    (ngModelChange)="onContratoClienteChange()"
                    [nzPlaceHolder]="t('tkt.novo.escolhaCliente')">
                    <nz-option *ngFor="let contrato of contratosDoCliente" [nzValue]="contrato.codecontract"
                        [nzLabel]="contrato.codecontract + ' - ' + contrato.nome"></nz-option>
                </nz-select>
                <span class="novo__hint">{{t('tkt.novo.clienteHint')}}</span>
            </div>

            <div class="novo__campo" *ngIf="!semCategorias">
                <label class="novo__label novo__label--req">
                    {{t('tkt.novo.categoria')}}
                </label>
                <!-- Cascata, e nao lista: a escolha desce pelo grupo e so
                     termina numa FOLHA, que e quem tem fila, SLA e prazo.
                     `nzChangeOnSelect` fica falso de proposito — parar num
                     grupo abriria chamado sem configuracao nenhuma. -->
                <!-- SEM ngModel de proposito.
                     O binding de formulario neste controle estourava
                     NG01203 (sem value accessor) ao abrir o modal. O cascader
                     ja expoe o caminho escolhido no proprio evento, que e o
                     que precisamos — e o `*ngIf` com contador recria o
                     controle quando a tela limpa, ja que sem ngModel nao ha
                     como zera-lo de fora. -->
                <nz-cascader *ngIf="cascaderVisivel" [nzOptions]="opcoes"
                    [nzChangeOnSelect]="false" nzShowSearch
                    (nzSelectionChange)="onCategoriaEscolhida($event)"
                    [nzPlaceHolder]="t('tkt.novo.escolhaCategoria')"></nz-cascader>
                <span class="novo__hint">{{t('tkt.novo.categoriaHint')}}</span>
            </div>

            <!-- Nenhuma categoria liberada para o app: o chamado ainda pode ser
                 aberto, e cai na categoria padrão da configuração. -->
            <nz-alert *ngIf="semCategorias" nzType="info" nzShowIcon
                [nzMessage]="t('tkt.novo.semCategoria')"
                [nzDescription]="t('tkt.novo.semCategoriaHint')"></nz-alert>

            <!-- A EMPRESA só é perguntada quando a fila da categoria pede.
                 Quem atende é que sabe se precisa saber de qual unidade do
                 cliente veio o problema. -->
            <div class="novo__campo" *ngIf="perguntaEmpresa">
                <label class="novo__label" [class.novo__label--req]="empresaObrigatoria">
                    {{t('tkt.novo.empresa')}}
                </label>
                <nz-select [(ngModel)]="empresaEscolhida" [nzAllowClear]="!empresaObrigatoria"
                    [nzPlaceHolder]="t('tkt.novo.escolhaEmpresa')">
                    <nz-option *ngFor="let empresa of empresas" [nzValue]="empresa.codecompany"
                        [nzLabel]="empresa.codecompany + ' - ' + empresa.nome"></nz-option>
                </nz-select>
                <span class="novo__hint">{{t('tkt.novo.empresaHint')}}</span>
            </div>

            <div class="novo__campo">
                <label class="novo__label novo__label--req">
                    {{t('tkt.campo.assunto')}}
                </label>
                <input nz-input [(ngModel)]="assunto" maxlength="120"
                    [placeholder]="t('tkt.novo.assuntoPlaceholder')">
            </div>

            <div class="novo__campo">
                <label class="novo__label novo__label--req">
                    {{t('tkt.novo.descricao')}}
                </label>
                <textarea nz-input rows="6" [(ngModel)]="descricao"
                    [placeholder]="t('tkt.novo.descricaoPlaceholder')"></textarea>
                <span class="novo__hint">{{t('tkt.novo.descricaoHint')}}</span>
            </div>

            <div class="novo__campo">
                <label class="novo__label">{{t('tkt.anexo.titulo')}}</label>

                <!-- `nzBeforeUpload` devolvendo false: quem sobe e o
                     AnexosService, porque e dele que volta o endereco do
                     arquivo. O nz-upload aqui e so o seletor. -->
                <nz-upload [nzBeforeUpload]="aoEscolherAnexo" [nzShowUploadList]="false"
                    [nzMultiple]="true" [nzDisabled]="enviandoAnexo">
                    <button nz-button type="button" [nzLoading]="enviandoAnexo">
                        <nz-icon nzType="paper-clip"></nz-icon>
                        {{t('tkt.anexo.escolher')}}
                    </button>
                </nz-upload>

                <div class="composer__subindo" *ngIf="enviandoAnexo">
                    <nz-spin nzSimple nzSize="small"></nz-spin>
                    <span>{{t('tkt.anexo.subindo')}}</span>
                </div>

                <div class="novo__anexos" *ngIf="anexos.length > 0">
                    <div class="novo__anexo" *ngFor="let anexo of anexos; let i = index">
                        <nz-icon nzType="paper-clip"></nz-icon>
                        <span class="novo__anexo-nome">{{anexo.nome}}</span>
                        <button nz-button nzType="text" nzSize="small" nzDanger
                            (click)="removerAnexo(i)">
                            <nz-icon nzType="close"></nz-icon>
                        </button>
                    </div>
                </div>

                <span class="novo__hint">{{t('tkt.anexo.hint')}}</span>
            </div>

            <!-- Prioridade e prazo são MOSTRADOS, nunca escolhidos: quem abre
                 não define a própria urgência. -->
            <div class="novo__previsto">
                <span>
                    <strong>{{t('tkt.campo.prioridade')}}:</strong>
                    <nz-tag>{{prioridadeLabel(prioridadePrevista)}}</nz-tag>
                </span>
                <span *ngIf="slaPrevisto != null">
                    <strong>{{t('tkt.novo.previsaoResposta')}}:</strong> {{slaPrevisto}}
                </span>
                <nz-icon nzType="question-circle" nz-tooltip
                    [nzTooltipTitle]="t('tkt.novo.previstoHint')"></nz-icon>
            </div>

            <div class="novo__acoes">
                <button nz-button (click)="fechar()">{{t('cancel')}}</button>
                <button nz-button nzType="primary" (click)="abrir()"
                    [nzLoading]="enviando" [disabled]="!podeEnviar">
                    <nz-icon nzType="send"></nz-icon>
                    {{t('tkt.novo.abrir')}}
                </button>
            </div>
        </div>

    </nz-spin>
</div>
